module.exports = __webpack_public_path__ + "img/home-dot-bris.336bf251.png";